// Recapiti pubblici: usati dal footer, dalla pagina contatti e dai dati strutturati.
export const CONTACT = {
  email: "admin@deloscielos.it",
  phone: "+39 3394727389",
  phoneE164: "+393394727389",
  whatsapp: "https://wa.me/393394727389",
  instagram: "https://instagram.com/deloscielos_experience",
  instagramHandle: "@deloscielos_experience",
  youtube: "https://www.youtube.com/channel/UCvTqPTOrs4oXyoirjXSj_JA",
};
